import { render, staticRenderFns } from "./pickupMember.vue?vue&type=template&id=2a911461&scoped=true&"
import script from "./pickupMember.vue?vue&type=script&lang=js&"
export * from "./pickupMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a911461",
  null
  
)

export default component.exports